import React, { useState } from "react";
import PropTypes from "prop-types";

// @mui
import Drawer from "@mui/material/Drawer";
import Container from "@mui/material/Container";

// locales
import { useLocales } from "src/locales";

// components
import CustomBreadcrumbs from "src/components/custom-breadcrumbs";
import Submit from "src/consuman-components/generic/submit";

//
import AuditEntityGrid from "../audit-entity-grid";

// ----------------------------------------------------------------------
const AuditDrawer = React.forwardRef(({ ...props }, ref) => {
  const { t } = useLocales();
  const [drawerOpen, setDrawerOpen] = useState(null);
  const [entityId, setEntityId] = useState(props.entityId);
  const [entity, setEntity] = useState({ entityName: props.entityName, entityId: props.entityId });
  const anchor = "right";

  const showDrawer = (entityName, entityId) => {
    setDrawerOpen(true);

    setEntity({ entityName, entityId });
  };

  const onClosed = () => {
    setDrawerOpen(false);
  };

  React.useImperativeHandle(ref, () => ({
    showDrawer,
  }));

  return (
    <Drawer
      PaperProps={{
        sx: { width: "50%" },
      }}
      anchor={anchor}
      open={drawerOpen}
      onClose={onClosed}
    >
      <Container sx={{ marginTop: "3%" }}>
        {drawerOpen ? (
          <>
            <CustomBreadcrumbs
              heading={t("viewGeneric", { label: t("audit") })}
              action={
                <Submit
                  onClick={onClosed}
                  showSave={false}
                  back
                />
              }
              sx={{
                mb: { xs: 3, md: 2 },
              }}
            />
            <AuditEntityGrid
              {...props}
              entityId={entity.entityId || props.entityId}
              entityName={entity.entityName || props.entityName}
            />
          </>
        ) : null}
      </Container>
    </Drawer>
  );
});

AuditDrawer.propTypes = {
  entityId: PropTypes.string,
  entityName: PropTypes.string,
};

export default AuditDrawer;
